/**
 * Bandeau "devise détectée" affiché en haut de la landing.
 * - Visible une seule fois par session (sessionStorage).
 * - Lien direct vers le SwitchDevise (intégré).
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../styles/tokens";
import useDevise from "../../hooks/useDevise";
import { isAfricanDevise } from "../../config/devises";
import SwitchDevise from "../SwitchDevise";

const DISMISS_KEY = "mm_devise_banner_dismissed";

export default function DeviseBanner() {
  const { devise, pays, drapeau, loading, autoDetected } = useDevise();
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" ? sessionStorage.getItem(DISMISS_KEY) === "1" : false
  );

  useEffect(() => {
    if (dismissed) {
      try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* quota */ }
    }
  }, [dismissed]);

  // Ne s'affiche pas tant que la détection n'est pas faite, ou si l'utilisateur
  // a choisi manuellement la devise, ou s'il a fermé le bandeau.
  if (loading || dismissed || !autoDetected || !pays) return null;

  const isFcfa = isAfricanDevise(devise);
  const introIcon = isFcfa ? "🌍" : drapeau;
  const intro = isFcfa
    ? `Prix affichés en FCFA pour ${pays}`
    : `Prix affichés en ${devise} pour ${pays}`;
  const extra = isFcfa ? " · Mobile Money disponible bientôt" : null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 110,
      background: `linear-gradient(90deg, ${colors.goldDim} 0%, ${colors.card} 100%)`,
      borderBottom: `1px solid ${colors.goldBorder}`,
      padding: "8px 12px",
      fontFamily: fonts.body,
      fontSize: 13,
      color: colors.text,
    }}>
      <div style={{
        maxWidth: 1200,
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
        justifyContent: "center",
      }}>
        <span style={{ fontSize: 16 }}>{introIcon}</span>
        <span style={{ flex: "0 1 auto" }}>
          {intro}{extra}
        </span>
        <SwitchDevise compact />
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Fermer"
          style={{
            background: "transparent",
            color: colors.textMuted,
            fontSize: 16,
            padding: "2px 8px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      </div>
      <div style={{
        maxWidth: 1200,
        margin: "4px auto 0",
        textAlign: "center",
        fontSize: 11,
        color: colors.textMuted,
        lineHeight: 1.4,
      }}>
        Votre IP est utilisée uniquement pour détecter votre pays.{" "}
        <Link to="/confidentialite" style={{ color: colors.gold, textDecoration: "underline" }}>
          En savoir plus →
        </Link>
      </div>
    </div>
  );
}
